/**
 * Overlays the content opened during this session onto the backend's `consumed` flag (IPD-3035).
 *
 * Explore keeps its rails alive and deliberately skips the refresh on a quick back navigation
 * (IPD-2938) so the restored scroll position does not shift under the user, and `consumed` only
 * ever changes server-side — so without this the Read / Listened / Watched marker did not appear
 * until a full reload.
 *
 * Two properties make it safe, and both depend on going through this helper rather than
 * re-implementing the expression per card family:
 *
 * - **Monotonic.** It only ever turns the marker ON. Viewing is irreversible, so it cannot be
 *   wrong in the direction that matters (marking something read that is not); at worst it agrees
 *   with the backend early.
 * - **Derived.** The item is copied, never mutated, so the next refresh cannot be clobbered by a
 *   stale local write — and the copy keeps its shape, so the cards render it unchanged and stay
 *   presentational.
 *
 * Callers supply `viewed` themselves because the id lives in a different place per family
 * (`item.content?.id` for library items, `content.id` for recommendations).
 */
export function withConsumed<T extends {consumed?: boolean | null}>(item: T, viewed: boolean): T {
  return !item.consumed && viewed ? {...item, consumed: true} : item;
}
